/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const sun_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.881 1v1.833m7.897 1.389-1.296 1.296m4.518 6.6h-1.833m-1.389 7.66-1.296-1.296M11.882 23v-1.833m-7.66-1.389 1.296-1.296M1 12.12h1.833m1.389-7.897 1.296 1.296m6.346 11.39a4.772 4.772 0 1 0 0-9.545 4.772 4.772 0 0 0 0 9.545Z"
    />
  </svg>
)
export default sun_medium
